<template>
  <div id="modalExamenContent">
    <div v-if="ciclo == 'intro'" class="container">
      <div class="row justify-content-center introHeader">
        <div class="col-auto">
          <h2>
            Bienvenido al examen <b>{{ nombre }}</b>
          </h2>
        </div>
      </div>
      <div class="row introHeader mt-3">
        <div class="col-12">
          <div class="container">
            <div class="row justify-content-around">
              <div class="col-4 text-right">
                <h6><b>numero de preguntas:</b></h6>
              </div>
              <div class="col-4 text-left">{{ totalIndex }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row introHeader mt-3">
        <div class="col-12">
          <div class="container">
            <div class="row justify-content-around">
              <div class="col-4 text-right">
                <h6><b>Tiempo estimado:</b></h6>
              </div>
              <div class="col-4 text-left">{{ detalle.tiempo_estimado }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3 mb-3 justify-content-center ql-container ql-snow">
        <div class="col-8 ml-5 ql-editor" v-html="detalle.descripcion_examen">
          {{ detalle.descripcion_examen }}
        </div>
      </div>
      <div class="row justify-content-between mb-5">
        <div class="col-2"></div>
        <div class="col-auto">
          <button class="btn btn-danger" data-dismiss="modal">Salir</button>
        </div>
        <div class="col-auto">
          <button
            class="btn btn-success"
            @click="
              () => {
                ciclo = 'cont';
                $emit('inicio');
              }
            "
          >
            Empezar
          </button>
        </div>
        <div class="col-2"></div>
      </div>
    </div>
    <div :class="ciclo == 'cont' ? '' : 'd-none'" class="container">
      <div class="row align-items-center justify-content-between mb-3">
        <div class="col-4">
          <div class="container">
            <div class="row">
              <h5 class="bold">
                {{ "Pregunta " + currentIndex + " de " + totalIndex }}
              </h5>
            </div>
            <div class="row">
              <div
                class="progress m-t-30"
                style="width: 20em; height: 1em; background-color: #d4d4d4"
              >
                <div
                  class="progress-bar bg-success"
                  :style="'width: ' + getPorcentaje + '%; height:5em;'"
                  role="progressbar"
                >
                  <span class="sr-only">60% Complete</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-auto" id="controlButtonsSection">
          <button
            class="btn btn-primary"
            href="#carouselPreguntas"
            role="button"
            :disabled="inhabilitar_siguiente"
            data-slide="next"
            v-if="currentIndex != totalIndex"
          >
            Siguiente
          </button>
          <button
            class="btn btn-primary"
            @click="terminar_examen"
            :disabled="inhabilitar_siguiente"
            v-else
          >
            Enviar respuestas
          </button>
        </div>
      </div>
      <div class="row preguntaDIV">
        <div class="col-12">
          <div
            id="carouselPreguntas"
            class="carousel slide"
            data-touch="false" data-wrap="false"
            data-ride="carousel"
          >
            <div class="carousel-inner">
              <div
                :class="'carousel-item ' + (index == 0 ? 'active' : '')"
                v-for="(pregunta, index) in preguntas"
                :key="'pregunta' + index"
              >
                <div class="container">
                  <div class="row">
                    <div class="col-12 text-center">
                      <h2 v-html="pregunta.label">{{ pregunta.label }}</h2>
                    </div>
                  </div>
                  <div
                    class="row justify-content-center"
                    v-if="pregunta.tipo_pregunta == 'texto'"
                  >
                    <div class="col-6 text-center textAreaSection">
                      <div class="input-group mb-3 w-100">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon1"
                            >Respuesta</span
                          >
                        </div>
                        <input
                          type="text"
                          class="form-control inputTextResp"
                          aria-describedby="basic-addon"
                          :name="'preguntaText' + index"
                          autocomplete="off"
                          v-model="pregunta.respuesta"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row" v-else>
                    <div>
                      <div
                        class="custom-control custom-checkbox mt-2"
                        v-for="(respuesta, index2) in respuestas"
                        :key="'respuesta' + index + index2"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="'customCheck' + index + index2"
                          :name="'checkRespuesta' + index + index2"
                          v-model="respuesta.selected"
                          v-if="
                            pregunta.tipo_pregunta.includes(
                              'múltiples respuestas'
                            )
                          "
                        />
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="'customCheck' + index + index2"
                          :name="'checkRespuesta' + index + index2"
                          v-model="respuesta.selected"
                          @click="reloadChecks(index2)"
                          v-else
                        />
                        <label
                          class="custom-control-label"
                          :for="'customCheck' + index + index2"
                          >{{ respuesta.label }}</label
                        >
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <li
        id="goto0"
        data-target="#carouselPreguntas"
        data-slide-to="0"
        class="active d-none"
      ></li>
    </div>
    <div class="container" v-if="ciclo == 'fin'">
      <div class="row justify-content-center">
        <h2>Examen completado</h2>
      </div>
      <div class="row justify-content-center">
        <div class="col-8">
          <div class="card-body">
            <div
              id="visitor"
              style="height: 223px; width: 100%"
              class="m-t-20"
            ></div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-5">
          <h4 class="text-center">
            Has terminado tu examen y te quedan
            {{ resultados.int_rest }} intentos.
            {{
              resultados.int_rest == 0
                ? "Tu calificacion se guardó exitosamente"
                : "Si quieres volver a presentar tu examen puedes hacerlo."
            }}
          </h4>
        </div>
      </div>
      <div class="row mt-2 justify-content-around">
        <div class="col-auto">
          <button class="btn btn-success" @click="ocultarModal">
            Terminar
          </button>
        </div>
        <!-- <div class="col-auto">
          <button class="btn btn-success" @click="ciclo = 'intro'">
            Volver a presentar
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import capacitacionxregion from "../../../Dashboard/CapacitacionxRegion/CapacitacionxRegion.vue";
export default {
  components: { capacitacionxregion },
  props: ["preguntas", "resultados", "nombre", "detalle"],
  data() {
    return {
      currentIndex: 1,
      columns: [],
      totalIndex: 1,
      ciclo: "intro",
      dataPreguntas: [],
      respuestas: [],
    };
  },
  methods: {
    Configurar_Grafica() {
      var chart = c3.generate({
        bindto: "#visitor",
        data: {
          columns: this.columns,

          type: "donut",
          onclick: function (d, i) {},
          onmouseover: function (d, i) {},
          onmouseout: function (d, i) {},
        },
        donut: {
          label: {
            show: false,
          },
          title: Math.round(this.resultados.calificacion),
          width: 15,
          expand: false,
        },
        tooltip: {
          show: true,
        },

        legend: {
          show: false,
          //or hide: 'data1'
          //or hide: ['data1', 'data2']
        },
        color: {
          pattern: ["#FF9900", "#7b7b7b"],
        },
      });
      d3.select(".c3-chart-arcs-title").attr("style", "font-size: 5em; fill:black").attr("dx", "-1.3em");

      // add percentage symbol
      d3.select(".c3-chart-arcs")
        .append("text")
        .text("%")
        .attr("dy", "0.2em")
        .attr("dx", "0.3em")
        .attr("style", "font-size: 5em; fill:black;");

      // black background for center text
      d3.select(".c3-chart")
        .insert("circle", ":first-child")
        .attr("cx", chart.internal.width / 2)
        .attr("cy", chart.internal.height / 2 - chart.internal.margin.top)
        .attr("r", chart.internal.innerRadius)
        .attr(
          "fill",
          "#fff"
        );;
    },
    ocultarModal() {
      console.log('DEBUG: ocultarModal',);
      $('.modal-backdrop').remove();
$('body').removeClass('modal-open');
      this.$emit("cerrar");
    },
    terminar_examen() {
      let that = this;
      this.ciclo = "fin";
      this.$emit("ActualizarExamen", this.dataPreguntas);
      this.respuestas.map(function (element, index) {
        that.dataPreguntas[that.dataPreguntas.length - 1].respuestas[
          index
        ].selected = element.selected;
      });

      this.$emit("terminar_examen");


      //this.ocultarModal();


      this.reiniciar();


    },
    reloadChecks(respuesta) {
      for (var i = 0; i < this.respuestas.length; i++) {
        if (i != respuesta) {
          this.respuestas[i].selected = false;
        }
      }
    },
    ActualizarExamen() {
      //console.log(this.preguntas);
      this.$emit("ActualizarExamen", this.dataPreguntas);
    },
    reiniciar() {
      this.currentIndex = 1;
      $("#goto0").click();
      let that = this;
      this.dataPreguntas[0]["estado"] = "active";
      this.totalIndex = this.dataPreguntas.length;
      this.respuestas = this.preguntas[0].respuestas.map((element) => {
        return { label: element.label, selected: element.selected };
      });
      this.vaciar();
      $("#carouselPreguntas").carousel({ interval: false, keyboard: false, touch: false });
      $("#carouselPreguntas").on("slid.bs.carousel", function () {
        that.currentIndex =
          $("#carouselPreguntas .carousel-item.active").index() + 1;
      });
    },
    vaciar() {
      this.dataPreguntas.forEach((element) => {
        if (element.tipo_pregunta == "text") {
          element["respuesta"] = "";
        } else {
          element.selected = "";
          element["estado"] = "";
          element.respuestas.forEach((el) => {
            el.selected = false;
          });
        }
      });
      this.dataPreguntas[0]["estado"] = "active";
    },
  },
  watch: {
    preguntas() {
      let temp = this.preguntas;
      this.dataPreguntas = temp;
      this.ciclo = "intro";
      this.reiniciar();
    },
    ciclo(newVal) {
      let that = this;
      // $("#carouselPreguntas").carousel({ interval: false, keyboard: false });
      // $("#carouselPreguntas").on("slide.bs.carousel", function() {
      //   that.currentIndex = $(
      //     "#carouselPreguntas .carousel-item.active"
      //   ).index();
      //   console.log($("#carouselPreguntas .carousel-item.active").index());
      // });
      this.reiniciar();
    },
    currentIndex(newVal, oldVal) {
      let that = this;
      this.respuestas.map(function (element, index) {
        that.dataPreguntas[oldVal - 1].respuestas[index].selected =
          element.selected;
      });
      console.log(that.dataPreguntas[oldVal - 1].respuestas);
      this.respuestas = this.preguntas[newVal - 1].respuestas.map((element) => {
        return { label: element.label, selected: element.selected };
      });
    },
    resultados() {
      this.columns = [
        ["Correctas", this.resultados.calificacion],
        ["Incorrectas", 100 - this.resultados.calificacion],
      ];
      this.Configurar_Grafica();
    },
  },
  mounted() {
    let temp = this.preguntas;
    this.dataPreguntas = temp;
    console.log(this.dataPreguntas[0]);
    this.reiniciar();
    this.Configurar_Grafica();
  },
  computed: {
    getPorcentaje() {
      let res = (Number(this.currentIndex) / this.totalIndex) * 100;
      return res;
    },
    inhabilitar_siguiente() {
      let pregunta = this.preguntas[this.currentIndex - 1];
      if (pregunta.tipo_pregunta == "texto") {
        return pregunta.respuesta == "";
      } else {
        for (let i = 0; i < this.respuestas.length; i++) {
          if (this.respuestas[i].selected) {
            return false;
          }
        }
      }
      return true;
    },
  },
};
</script>

<style scoped>
#visitor {
  width: 150px;
  height: 150px;
}

/* don't do anything fancy when hovering */
#visitor /deep/ .c3-defocused.c3-target {
  opacity: 1 !important;
}

#visitor /deep/ text {
  fill: #ccc;
}

#visitor /deep/ .c3-chart-arcs-title {
  fill: white;
  font-size: 3em;
}
.bg_primary {
  background-color: #007bff61 !important;
}
.colBtn-respuesta {
  padding: 0.5em;
}
.btn-outline-primary {
  border-color: #ff9900;
  color: #ff9900;
  background-color: #ffffff !important;
}
.btn-outline-primary:hover {
  border-color: #ff9900;
  color: #ffffff;
  background-color: #ff9900 !important;
}
.btn-outline-primary:focus,
.btn:focus {
  box-shadow: 0 0 0 0 rgba(255, 153, 0, 0.575) !important;
}
.btn-outline-primary.active,
.btn-outline-primary:not(:disabled):not(.disabled).active {
  border-color: #ff9900 !important;
  background-color: #ff9900 !important;
  color: #ffffff !important;
}
.btn-outline-primary.active:hover {
  background-color: #ff9900 !important;
  color: #ffffff;
}
.btnSection {
  padding-top: 0.5em;
}
#controlButtonsSection {
  margin-top: 2em;
}
.bold {
  font-weight: 600 !important;
}

.labelPregunta {
  font-size: 1.8em;
  padding-left: 1em;
}

.preguntaDIV /deep/ .custom-control-label::after,
.preguntaDIV /deep/ .custom-control-label::before {
  height: 1.4em;
  width: 1.4em;
}
.custom-control-label {
  font-size: 1.5em;
  padding-left: 1em;
  padding-bottom: 0.2em;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #00ab53;
  background-color: #00ab53;
}

.rowPregunta {
  margin-bottom: 1em;
}

.lineGrayDivisor {
  width: 100%;
  border-style: solid;
  border-radius: 2px;
  margin-top: 1em;
  margin-bottom: 1em;
  border-color: #7d7d7d !important;
  border-width: 2px;
}
.inputTextResp {
  font-size: 1.5em;
}

.row.ql-container.ql-snow {
  border-style: none;
}

#modalExamenContent{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Plan_Capacitacion/Consultar_Plan_Capacitacion/acciones/presentar_examen.vue